import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { CourseType, LessonType } from '../../types'

type InitialState = {
  lesson?: LessonType
  course?: CourseType
  tab: 'about' | 'resources' | 'workbook'
  loading: boolean
  showSidebar?: boolean
}

const initialState: InitialState = {
  loading: true,
  tab: 'about'
}

export const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setLessonTab: (state, action: PayloadAction<InitialState['tab']>) => {
      state.tab = action.payload
    },
    setLesson: (state, action: PayloadAction<InitialState['lesson']>) => {
      state.lesson = action.payload
      state.tab = 'about'
    },
    updateLesson: (state, action: PayloadAction<Partial<InitialState['lesson']>>) => {
      state.lesson = {
        ...state.lesson,
        ...action.payload
      } as any
    },
    updateCourseLesson: (
      state,
      action: PayloadAction<{ _id: string; lesson: Partial<InitialState['lesson']> }>
    ) => {
      state.course = {
        ...state.course,
        modules: (state.course?.modules || []).map((m) => ({
          ...m,
          lessons: m.lessons.map((l) => {
            if (l._id === action.payload._id) {
              return {
                ...l,
                ...action.payload.lesson
              }
            }

            return l
          })
        }))
      } as any
    },
    setCourse: (state, action: PayloadAction<InitialState['course']>) => {
      state.course = action.payload
    },
    setCourseLoading: (state, action: PayloadAction<InitialState['loading']>) => {
      state.loading = action.payload
    },
    setShowLessonSidebar: (state, action: PayloadAction<InitialState['showSidebar']>) => {
      state.showSidebar = action.payload
    }
  }
})

export const {
  setLessonTab,
  setLesson,
  updateLesson,
  updateCourseLesson,
  setCourse,
  setCourseLoading,
  setShowLessonSidebar
} = courseSlice.actions
export default courseSlice.reducer
